var map = {
	"./clinic.svg": 607,
	"./hospital.svg": 9537,
	"./international.svg": 5185,
	"./newCenter.svg": 1104,
	"./precisionMedicine.svg": 2733,
	"./qcga.svg": 9399,
	"./quality.svg": 6178,
	"./research_center.svg": 5064,
	"./smartHealthcare.svg": 5811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6869;